import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { addAllCars } from "sources/books/usersGroups";

export default function AddAllCarsToGroup(props) {
    const [loading, setLoading] = useState(false);
    const forceMove = () => {
        setLoading(true);
        addAllCars({ groupId: props.groupId, forceMoveOnConflicting: true }).then((res) => {
            if (res) {
                props.mergeParams();
                props.back();
            }
            setLoading(false);
        });
    };
    const action = () => {
        setLoading(true);
        addAllCars({ groupId: props.groupId }).then((res) => {
            setLoading(false);
            props.back();
            if (res?.failedCars?.length) {
                props.add({
                    name: "default",
                    windowMod: "wide",
                    title: "Следующие машины не были добавлены, потому что находятся в других группах",
                    CustomBody: () => (
                        <div>
                            <p className="alert alert-warning font-size-14">
                                Вы можете перенести машины в эту группу и они будут удалены из своих текущих групп.
                            </p>
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Машина</th>
                                        <th>Группа</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {res.failedCars.map((item, i) => (
                                        <tr key={item.carId}>
                                            <td>{i + 1}</td>
                                            <td>
                                                <Link target="blank" to={paths.trucksShow(item.carId)}>
                                                    {item.carNumber}
                                                </Link>
                                            </td>
                                            <td>
                                                <Link target="blank" to={paths.usersGroupsShow(item.groupId)}>
                                                    {item.groupName}
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="d-flex justify-content-end">
                                <div className="btn btn-sm btn-brand" onClick={forceMove}>
                                    Перенести машины в группу
                                </div>
                            </div>
                        </div>
                    ),
                });
            }
            props.mergeParams({});
        });
    };
    if (loading) {
        return <Loader />;
    }
    return (
        <div>
            <div className="modal-window__body">Вы уверены, что хотите все машины в группу?</div>
            <div className="modal-window__footer">
                <div className="btn btn-secondary btn-sm modal-window__footer-action" onClick={() => props.back()}>
                    Отменить
                </div>
                <div className="btn btn-brand btn-sm modal-window__footer-action" onClick={action}>
                    Добавить
                </div>
            </div>
        </div>
    );
}
